import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NewsletterForm from './components/newsletter/NewsletterForm';
import Footer from './components/footer/Footer';
import Cardcursopythonia from './components/cardcursopythonia/Cardcursopythonia';
import Quote from './components/quote/Quote';
import Cursoprompt from './components/cursoprompt/Cursoprompt';
import Nav from './components/nav/Nav';
import Home from './components/home/Home';
import Cursopythonia from './components/cursopythonia/Cursopythonia';
import Cardcursoprompt from './components/cardcursoprompt/Cardcursoprompt';
import Acercade from './components/acercade/Acercade';
import useTitle from './components/useTitle';
import IAQuees from './components/IAQuees/IAQuees';
import MLQuees from './components/MLQuees/MLQuees';


function App() {

  useTitle('Inteligencia Artificial');
  
  return (
    <div className="App">
    <Router>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} /> {/* Assuming you have a Home component */}
        <Route path="/curso-python-ia" element={<Cursopythonia />} />
        <Route path="/curso-prompt-engineering" element={<Cursoprompt />} />
        <Route path="/acerca-de-aprender-ia" element={<Acercade />} />
        <Route path="/inteligencia-artificial-que-es" element={<IAQuees />} />
        <Route path="/machine-learning-que-es" element={<MLQuees />} />
        {/*<Route path="/ia-general" element={<IAGeneral />} />*/}
      </Routes>
    </Router>
      <Quote/>
      <div className="w3-container w3-margin w3-flex" style={{ flexWrap: 'wrap', justifyContent: 'center' }}>
        <NewsletterForm/>
        <Cardcursoprompt/>
        <Cardcursopythonia/>
      </div>
      <Footer/>
    </div>
  );
}

export default App;
